let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dGznG")).then(() => parcelRequire('qNI6O'));